<template>
  <div>
    <modal v-if="save" xsmall @close="save = false" class="save">
      <div slot="body">
        <div class="p-5 text-center">
          <h2>{{ $t('airportparking.results.save') }}</h2>
          <h4>{{ $t('airportparking.results.save_fill') }}</h4>
          <div class="input-group mt-4">
            <input 
              type="email" 
              class="form-control"
              :class="{ 'border-danger' : emailError }"
              v-model="email"
              :placeholder="$t('airportparking.results.product.email_address')" 
              :aria-label="$t('airportparking.results.product.email_address')"
            />
            <div class="input-group-append">
              <button class="btn btn-secondary" @click="saveLater" type="button">{{ $t('airportparking.results.product.save') }}</button>
            </div>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { sync, call, get } from "vuex-pathify";
import mixins from "@/mixins";
import { Modal } from "@/components";
import { eventBus } from "@/eventBus"

export default {
  name: "save",
  mixins: [mixins.load, mixins.validate],
  components: { Modal },
  data() {
    return {
      email: '',
      emailError: false
    }
  },
  computed: {
    save: sync('modals/save'),
    quote: get('quote'),
    airport: get('results/airport'),
    results: sync('results/products@airportparking')
  },
  methods: {
    saveProduct: call("results/saveForLater"),
    saveLater() {
      if(this.validEmail(this.email)) {

        this.emailError = false;

        let payload = {
          email: this.email,
          product: {
            "id": this.save.park_id,
            "name": this.save.park_name,
            "price": parseFloat(this.save.price).toFixed(2),
            "salePrice": parseFloat(this.save.full_price).toFixed(2),
            "discount": parseFloat(this.save.full_price - this.save.price).toFixed(2),
            "dateTimeA": `${this.quote.dateA} ${this.quote.timeA}`,
            "dateTimeB": `${this.quote.dateB} ${this.quote.timeB}`,
            "airportName": this.airport.airport_name
          }
        }

        this.$router.replace({ query: Object.assign({}, {...this.$route.query, email: payload.email, ...payload.product }) }, () => {})

        this.saveProduct(payload).then(() => {
          eventBus.$emit('SAVED', this.save.park_id)
          this.save = false;
        })
      } else {
        this.emailError = true;
      }
    }
  }
};
</script>